module.exports = __webpack_public_path__ + "img/bg-header.bf2b3f13.webp";